import styled from 'styled-components';

import InfinitelyScrolled from '../../../components/InfinitelyScrolled';
import { ShimmerImage, ShimmerProps, ShimmerText } from '../../../components/Shimmer';
import { ThemeProp } from '../../../theme/Themes';

export const NotificationsEmptyContainer = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.5rem;
`;

export const EmptyNotificationsMessage = styled.p`
  font-size: ${(props: ThemeProp) => props.theme.fontSize.l};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.l};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  max-width: 15rem;
  text-align: center;
`;

export const NotificationDivider = styled.div`
  hr {
    background-color: ${(props: ThemeProp) => props.theme.colors.greyscale.c800};
  }
`;

interface NotificationItemContainerProps {
  hoverEffect?: boolean;
}
export const NotificationItemContainer = styled.div<NotificationItemContainerProps>`
  padding: 0 0.5rem;

  ${(props: NotificationItemContainerProps) => {
    if (props.hoverEffect) {
      return `
        &:hover {
          ${NotificationDivider} {
            hr {
              background: transparent;
            }
          }
        }
      `;
    }
    return null;
  }}

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 0;
  }
`;

export const StyledTextShimmer = styled(ShimmerText).attrs((props: ThemeProp & ShimmerProps) => ({
  $height: `.75rem`,
  $width: props.$width,
  ...props,
}))<ShimmerProps>`
  display: flex;
  flex: 0;

  .shimmer {
    -webkit-mask: linear-gradient(to right, #000, #0000);
    mask: linear-gradient(to right, #000, #0000);
  }
`;

export const ShimmerTextContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
`;

export const StyledImageShimmer = styled(ShimmerImage).attrs((props: ThemeProp) => ({
  ...props,
  $height: '41px !important',
  $width: '55px',
}))`
  margin-right: 0.75rem;
  &.shimmer {
    -webkit-mask: linear-gradient(to right, #000, #0000);
    mask: linear-gradient(to right, #000, #0000);
  }
`;

export const StyledImageShimmerContainer = styled.div`
  flex: 1;
  max-width: 55px;
  margin-right: 0.75rem;
`;

export const ShimmerItemContainer = styled.div`
  display: flex;
  padding: 0.5rem 0.5rem 1rem 0.5rem;
`;

export const StyledDefaultHeader = styled.div`
  padding-left: 0.5rem;
  font-size: ${(props: ThemeProp) => props.theme.fontSize.l};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.l};
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  margin-bottom: 2rem;
`;

// Used for hiding the header in mobile devices
export const HeaderContainer = styled.div`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const StyledInfiniteScroll = styled(InfinitelyScrolled)`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;
